// translations.js
export const translations = {
  ar: {
    // Header
    logo: "مانسكتوش على العنف 2025",
    home: "الرئيسية",
    about: "عن الحملة",
    caravan: "قافلة وطنية",
    stands: "معارض",
    numbers: "العنف الرقمي: أرقام ووثائق",
    spectacle: "تعابير الحق",
    downloadProgram: "تحميل البرنامج",

    // About Section
    aboutTitle: "عن الحملة",
    aboutIntro: "حملة وطنية لمناهضة العنف الرقمي ضد النساء والفتيات",
    duration: "16 يوم",
    dates: "25 نونبر - 10 دجنبر",
    atCouncil: "بالمجلس",
    nationalCaravan: "قافلة وطنية",
    exhibitions: "معارض",
    expressions: "تعابير الحق",
    more: "المزيد",

    // Tabs
    headquarters: "في المجلس",
    conference: "ندوة",
    conferenceDesc: "ندوة وطنية تحت شعار \"العنف الذي تيسره التكنولوجيا ضد النساء والفتيات - جائحة رقمية صامتة\"، بمشاركة مؤسسات وقطاعات وفاعلين وخبراء، مغاربة، أفارقة، دوليين وأمميين",
    show: "عرض ضوئي - Mapping",
    showDesc: "أرقام، رسائل، تعبيرات ولوحات : عروض ضوئية على الواجهة الرئيسة لبناية المجلس الوطني لحقوق الإنسان للتحسيس ومناهضة العنف الرقمي ضد النساء والفتيات",
    caravanDesc: "قافلة متنقلة تجوب 12 مدينة ب 12 جهة طيلة أيام الحملة للقاء والتفاعل والتحسيس حول العنف الذي تيسره التكنولوجيا ضد النساء والفتيات",
    musicDesc: "تعابير الحقوق: عروض فنية يومية في فضاءات مفتوحة، بمعارض مناهضة العنف ضد النساء والفتيات. تعابير وإبداعات شبابية للتعبير عن الحقوق، يوميا من الساعة السادسة إلى السادسة والنصف مساء",
    standsDesc: "أروقة ومعارض بساحات عمومية كبرى بمدينة الرباط (3 معارض، 3 فضاأت مختلفة) للتفاعل مع سكان العاصمة والقادمين إليها ومغادريها حول مخاطر العنف الرقمي ضد النساء والفتيات وسبل الوقاية منه والتبليغ عنه",
    closingEventDesc: "حفل تعابير الحق: تعبيرات فنية، تختتم حملة وطنية لمناهضة العنف الرقمي ضد النساء والفتيات وتخلد اليوم العالمي لحقوق الإنسان 80",

    // Video Section
    testimonials: "شهادات",
    watchMore: "شاهد المزيد من الشهادات",
    video1Title: "شهادة ضحية عنف رقمي",
    video1Desc: "قصة حقيقية لامرأة تعرضت للابتزاز الإلكتروني وكيف تغلبت على محنتها",
    video2Title: "التحرش عبر مواقع التواصل",
    video2Desc: "شاب يروي تجربته مع التنمر الإلكتروني وتأثيره على حياته اليومية",
    video3Title: "الانتقام الإلكتروني",
    video3Desc: "كيف تحولت علاقة عاطفية إلى كابوس رقمي وطرق الحماية القانونية",

    // Countdown
    countdownTitle: "الوقت المتبقي لانطلاق الحملة",
    days: "يوم",
    hours: "ساعة",
    minutes: "دقيقة",
    seconds: "ثانية",

    // Footer
    footerDescription: "حملة وطنية لمناهضة العنف الرقمي ضد النساء والفتيات",
    quickLinks: "روابط سريعة",
    contactInfo: "معلومات التواصل",
    followUs: "تابعونا على",
    country: "المغرب",
    copyright: "© 2025 حملة وطنية لمناهضة العنف الرقمي ضد النساء والفتيات. جميع الحقوق محفوظة."
  },

  en: {
    // Header
    logo: "SPEAK OUT AGAINST GENDER-BASED VIOLENCE 2025",
  home: "Home",
  about: "About the campaign",
  caravan: "National caravan",
  stands: "Exhibitions",
  numbers: "Digital violence: Data & resources",
  spectacle: "Expressions of rights",
  downloadProgram: "Download program",
  languageSelector: "AR | EN | AMZ",
      // About Section
      aboutTitle: "About the campaign",
      aboutIntro: "National campaign against digital violence against women and girls",
      duration: "16 days",
      dates: "November 25 - December 10",
      atCouncil: "At the Council",
      nationalCaravan: "National caravan",
      exhibitions: "Exhibitions",
      expressions: "Rights expressions",
      more: "More",

    // Tabs
    headquarters: "At the Council",
    conference: "Conference",
    conferenceDesc: "National conference on \"Technology-Facilitated Violence Against Women and Girls - A Silent Digital Pandemic\", with participation from institutions, sectors, actors, and experts - Moroccan, African, international and UN representatives",
    show: "Light Show - Mapping",
    showDesc: "Numbers, messages, expressions and paintings: light shows on the main facade of the National Council for Human Rights building to raise awareness and combat digital violence against women and girls",
    caravanDesc: "A mobile caravan touring 12 cities in 12 regions throughout the campaign days to meet, interact and raise awareness about technology-facilitated violence against women and girls",
    musicDesc: "Rights expressions: daily artistic performances in open spaces, with exhibitions against violence against women and girls. Youth expressions and creations to express rights, daily from 6:00 to 6:30 PM",
    standsDesc: "Pavilions and exhibitions in major public squares in Rabat (3 exhibitions, 3 different spaces) to interact with capital residents, visitors and travelers about the dangers of digital violence against women and girls and ways to prevent and report it",
    closingEventDesc: "Rights Expressions Ceremony: artistic expressions, concluding the national campaign against digital violence against women and girls and commemorating the 80th International Human Rights Day",

    // Video Section
    testimonials: "Testimonials",
    watchMore: "Watch More Testimonials",
    video1Title: "Testimony of a Digital Violence Victim",
    video1Desc: "A true story of a woman who experienced cyberbullying and how she overcame her ordeal",
    video2Title: "Harassment via Social Media",
    video2Desc: "A young man recounts his experience with cyberbullying and its impact on his daily life",
    video3Title: "Digital Revenge",
    video3Desc: "How a romantic relationship turned into a digital nightmare and legal protection methods",

    // Countdown
    countdownTitle: "Time Remaining Until Campaign Launch",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",

    // Footer
    footerSlogan: "Speak out against gender-based violence",
  footerDescription: "A national campaign to end digital violence against women and girls",
  quickLinks: "Quick links",
  home: "Home",
  about: "About the campaign",
  caravan: "National caravan",
  stands: "Exhibitions",
  numbers: "Digital violence: Data & resources",
  spectacle: "Expressions of rights",
  contactInfo: "Contact information",
  email: "cndh@cndh.org.ma",
  phone: "+212 537 430 000",
  country: "Morocco",
  followUs: "Follow us",
  facebook: "CNDHMaroc.ar",
  twitter: "CNDHMaroc",
  youtube: "CNDHMaroc",
  instagram: "cndhmaroc",
  copyright:
    "© 2025 Campaign against technology-facilitated violence. All rights reserved.",

  },

  amz: {
    // Header (Amazigh - pour l'instant en gardant certains termes)
    logo: "ⴰⴷ ⵓⵔ ⵏⴰⴼⵉⵙⵙ ⵅⴼ ⵜⴽⵕⴹⵉ 2025",
    home: "ⴰⵙⵏⵓⴱⴳ",
    about: "ⵅⴼ ⵓⵎⵣⵉⵣⵣⵍ",
    caravan: "ⴰⴽⴰⴱⴰⵕ ⴰⵏⴰⵎⵓⵔ",
    stands: "ⵉⴼⵙⴰⵔⵏ",
    numbers: "ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ: ⵓⵟⵟⵓⵏⵏ ⴷ ⵜⵏⵜⴰⵎⵉⵏ",
    spectacle: "ⵉⵡⵏⵏⵉⵜⵏ ⵏ ⵓⵣⵔⴼ",
    downloadProgram: "ⴰⴳⴰⵎ ⵏ ⵓⵖⴰⵡⴰⵙ",

    // About Section
    aboutTitle: "Ɣef temẓaɣt",
    aboutIntro: "Tamẓaɣt tanamurt mgal lɛunf umḍin ɣef tlawin d tneɣmisin",
    duration: "16 wussan",
    dates: "25 Nwanbir - 10 Dujanbir",
    atCouncil: "Deg usqamu",
    nationalCaravan: "Takrṛabt tanamurt",
    exhibitions: "Tiɣbula",
    expressions: "Asenfali n yizerfan",
    more: "Ugar",

    // Tabs
    headquarters: "Deg usqamu",
    conference: "Asarag",
    conferenceDesc: "Asarag anamur s usentel \"Lɛunf i yessefsayen ttiknulujit mgal tlawin d tneɣmisin - Tawla tumḍint taneṣbant\", s uttekki n yimussan, iɣerbazen, imḥerken d yinaẓuren - imurakuciyen, ifruqiyen, iddukulanen d wid n NNNU",
    show: "Askan s tafat - Mapping",
    showDesc: "Uṭṭunen, tiznan, asenfali d tellisin: askan s tafat ɣef tɣezrant tagejdant n lebni n usqamu anamur n yizerfan n ufgan i useftiyen d umnaɣ mgal lɛunf umḍin mgal tlawin d tneɣmisin",
    caravanDesc: "Takrṛabt tatṭabaḍt tessawaḍ 12 n tmdinin deg 12 n tmura ɣef ussan n temẓaɣt i umlaqat, amyigawas d useftiyen ɣef lɛunf i yessefsayen ttiknulujit mgal tlawin d tneɣmisin",
    musicDesc: "Asenfali n yizerfan: iskanwen n tɣuri yal ass deg iɣezranen yeldin, s tiɣbula mgal lɛunf mgal tlawin d tneɣmisin. Asenfali d tmerna n tlawin i usenfali n yizerfan, yal ass seg 6:00 ar 6:30 n tmeddit",
    standsDesc: "Tiɣbula d tiɣbula deg yiswiren igejdanen n Rbaṭ (3 n tiɣbula, 3 n yiɣezranen imgaraden) i umyigawas d yimezdaɣen n temdint d wid i d-yusan d wid i yeffɣen ɣef lɣezz n lɛunf umḍin mgal tlawin d tneɣmisin d tuɣalin i usewqay d ummul-is",
    closingEventDesc: "Tameɣra n usenfali n yizerfan: asenfali n tɣuri, i yettfarsen tamẓaɣt tanamurt mgal lɛunf umḍin mgal tlawin d tneɣmisin d tezmert n wass agraɣlan n yizerfan n ufgan 80",

    // Video Section
    testimonials: "Tineɣmisin",
    watchMore: "Wali ugar n tineɣmisin",
    video1Title: "Tineɣmist n yiwet n tmeṭṭut i yuɣen lɛunf umḍin",
    video1Desc: "Taqsiṭ tideṭ n yiwet n tmeṭṭut i yuɣen asenked asabruran d wamek i teɣleb ɣef lexṣaṣ-is",
    video2Title: "Asenker deg yismal n usmekti",
    video2Desc: "Argaz ameẓyan yettḥekki ɣef tirmit-is d asenked asabruran d wayes yessukud deg tudert-is n yal ass",
    video3Title: "Tamanɣa tumḍint",
    video3Desc: "Amek i tuɣal talɣa taɣelnawt d targit tumḍint d tuɣalin i ummesten uzerfan",

    // Countdown
    countdownTitle: "Akud i d-yeqqimen i usenker n temẓaɣt",
    days: "Ussan",
    hours: "Isragen",
    minutes: "Tesdatin",
    seconds: "Tasinin",

    // Footer
    // Section contact
      contactInfo: "ⵓⵎⵍⴰⵏ ⵏ ⵓⵎⵢⴰⵡⴰⴹ",
      email: "ⵜⴰⵙⴰⵡⴰⵢⵜ ⵜⴰⵍⴽⵟⵕⵓⵏⵉⵜ",
      phone: "ⵜⵜⵉⵍⵉⴼⵓⵏ",
      location: "ⴰⵏⵙⴰ",
      country: "ⵍⵎⵖⵔⵉⴱ",

      // Section réseaux sociaux
      followUs: "ⴹⴼⵓⵕⴰⵜ ⴰⵖ ⴳ",
      socialMediaTitle: "ⴰⴳⵣⵣⵓⵎ ⵡⵉⵙⵙ ⴽⴽⵓⵥ: ⵉⵎⴰⵙⵙⵏ ⵏ ⵓⵎⵢⴰⵡⴰⴹ ⴰⵏⴰⵎⵓⵏ",

        quickLinks: "ⵉⵙⵖⵓⵏⵏ ⵓⴷⵔⵉⴼⵏ",
footerDescription:"ⴰⵎⵣⵉⵣⵣⵍ ⴰⵏⴰⵎⵓⵔ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ",
copyright:"© 2025 ⴰⵎⵣⵉⵣⵣⵍ ⴰⵏⴰⵎⵓⵔ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ. ⴰⴽⴽⵯ ⵉⵣⵔⴼⴰⵏ ⵜⵜⵡⴰⵃⴹⴰⵏ.",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.ar[key];
};
